package br.com.texeratx.boardgametimeapp.core.spotify.auth

import kotlin.random.Random
import kotlin.math.min

object PkceUtil {
    // RFC 7636 allowed chars
    private const val ALPHABET = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~"

    fun newCodeVerifier(length: Int = 64): String {
        require(length in 43..128)
        return buildString(length) {
            repeat(length) { append(ALPHABET[Random.nextInt(ALPHABET.length)]) }
        }
    }

    fun newState(length: Int = 32): String {
        val len = min(64, maxOf(16, length))
        return buildString(len) {
            repeat(len) { append(ALPHABET[Random.nextInt(ALPHABET.length)]) }
        }
    }

    /**
     * S256 = base64url( SHA256(verifier) )
     */
    fun codeChallengeS256(verifier: String): String {
        val digest = sha256(verifier.encodeToByteArray())
        return base64UrlNoPadding(digest)
    }

    // --------- helpers (sem libs extras) ---------
    private fun sha256(input: ByteArray): ByteArray {
        // Kotlin Multiplatform: usa kotlinx-io ByteString como fallback simples
        // (se você já tem outra lib/impl no projeto, pode trocar aqui depois)
        // Para manter 100% KMP sem dependência, vamos usar java.security no Android/JVM e wasm/js via expect no passo seguinte
        // -> por enquanto vamos delegar para uma expect/actual
        return SpotifyCrypto.sha256(input)
    }

    private fun base64UrlNoPadding(bytes: ByteArray): String {
        return SpotifyCrypto.base64UrlNoPadding(bytes)
    }
}
